export interface CategoryInfo {
  name: string;
  slug: string;
  intro: string;
  icon: string;
  accent: string;
}

export const categories: CategoryInfo[] = [
  {
    name: "情侣自拍",
    slug: "情侣自拍",
    intro: "以两人日常为主线的自然记录，强调真实的氛围、生活化的场景与不刻意设计的镜头语言。",
    icon: "ri-heart-3-line",
    accent: "自拍记录",
  },
  {
    name: "业余风",
    slug: "业余风",
    intro: "手持、自然光、无脚本的素人视角记录，画面带着轻微的呼吸感与随性节奏。",
    icon: "ri-camera-lens-line",
    accent: "素人视角",
  },
  {
    name: "校园风",
    slug: "校园风",
    intro: "校园、图书室、操场与夏日教室，主打清爽干净的胶片质感与怀旧氛围。",
    icon: "ri-book-open-line",
    accent: "青春氛围",
  },
  {
    name: "素人系列",
    slug: "素人系列",
    intro: "来自日本与韩国不同城市的素人记录，题材覆盖屋顶、老城巷子、海边与日常室内场景。",
    icon: "ri-user-star-line",
    accent: "城市记录",
  },
  {
    name: "温泉旅拍",
    slug: "温泉旅拍",
    intro: "山间温泉旅馆与雪国旅拍，长镜头与自然声场为主，画面安静，适合放松观看。",
    icon: "ri-water-flash-line",
    accent: "旅途慢拍",
  },
  {
    name: "女优合集",
    slug: "女优合集",
    intro: "精选合集栏目，按拍摄风格与布光类型整理，视觉完成度较高，支持多机位版本。",
    icon: "ri-star-smile-line",
    accent: "编辑精选",
  },
];

export const regions = ["日本", "韩国"];

export const perspectives = ["男女合拍", "女性视角", "男性视角"];

export const years = [2026, 2025, 2024];

export const sortOptions = [
  { key: "latest", label: "最新上传" },
  { key: "popular", label: "最多观看" },
  { key: "duration", label: "时长最长" },
];